var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 11.25H9C6.51472 11.25 4.5 13.2647 4.5 15.75V38.25C4.5 40.7353 6.51472 42.75 9 42.75H45C47.4853 42.75 49.5 40.7353 49.5 38.25V15.75C49.5 13.2647 47.4853 11.25 45 11.25Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0034 29.0026C18.8142 29.0032 18.6286 28.9502 18.4684 28.8496C18.3081 28.749 18.1796 28.605 18.098 28.4343C18.0163 28.2636 17.9847 28.0732 18.0069 27.8853C18.0291 27.6973 18.1042 27.5196 18.2234 27.3726L28.1234 17.1726C28.1977 17.0869 28.2989 17.029 28.4104 17.0083C28.5219 16.9877 28.6371 17.0056 28.7371 17.0591C28.8371 17.1126 28.916 17.1985 28.9607 17.3027C29.0055 17.4069 29.0135 17.5233 28.9834 17.6326L27.0634 23.6526C27.0068 23.8041 26.9878 23.9671 27.008 24.1276C27.0282 24.2881 27.0871 24.4413 27.1795 24.574C27.2719 24.7068 27.3952 24.8151 27.5387 24.8898C27.6822 24.9644 27.8417 25.0031 28.0034 25.0026H35.0034C35.1926 25.002 35.3782 25.055 35.5385 25.1556C35.6987 25.2562 35.8272 25.4002 35.9089 25.5709C35.9905 25.7416 36.0221 25.932 35.9999 26.1199C35.9777 26.3079 35.9026 26.4856 35.7834 26.6326L25.8834 36.8326C25.8091 36.9183 25.708 36.9762 25.5964 36.9969C25.4849 37.0175 25.3697 36.9996 25.2697 36.9461C25.1697 36.8926 25.0908 36.8067 25.0461 36.7025C25.0013 36.5983 24.9933 36.482 25.0234 36.3726L26.9434 30.3526C27 30.2011 27.019 30.0381 26.9988 29.8776C26.9786 29.7171 26.9198 29.5639 26.8273 29.4312C26.7349 29.2984 26.6116 29.1901 26.4681 29.1154C26.3246 29.0408 26.1652 29.0021 26.0034 29.0026H19.0034Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCard);
export default __webpack_public_path__ + "static/media/icon-card.459c4cb786a1084955bc05ffc316341f.svg";
export { ForwardRef as ReactComponent };